/* import Swiper core, modules, and css */
// import Swiper from 'swiper';
// import { Pagination, Autoplay, Navigation } from 'swiper/modules'; // import Swiper modules (if needed). Full list available here: https://swiperjs.com/swiper-api#modules

import './index.scss'

class HeroBanner {
    constructor(el) {
        this.$el = el

        // console.log('HeroBanner::constructor')
    }
    init() {

        // console.log('HeroBanner::init')
        const $nav = document.querySelector('.navigation-container')
        const $logo = $nav.querySelector('.mainmenu__logo')
        // console.log('firstElementChild', document.querySelector('main[role="main"]').firstElementChild)
        // console.log('this.$el', this.$el)
        if (this.$el === document.querySelector('main[role="main"]').firstElementChild) {
            this.createMainmenuObserver($nav, $logo)
        } else {
            $nav.dataset.isTransparent = false
            // $logo.src = $logo.dataset.logoUrl
        }
    }
    createMainmenuObserver($nav, $logo) {
        const callback = (entries, observer) => {
            entries.forEach((entry) => {
                // Each entry describes an intersection change for one observed
                // target element:
                //   entry.boundingClientRect
                //   entry.intersectionRatio
                //   entry.intersectionRect
                //   entry.rootBounds
                //   entry.target
                //   entry.time
                if (entry.isIntersecting) {
                    $nav.dataset.isTransparent = true
                    // $logo.src = $logo.dataset.logoWhiteUrl
                    
                } else {
                    $nav.dataset.isTransparent = false
                    // $logo.src = $logo.dataset.logoUrl
                }
            })
        }
    
        const options = {
          root: null,
          rootMargin: "-99% 0% 0% 0%",
          threshold: 0,
        }
        
        /* global IntersectionObserver */
        const observer = new IntersectionObserver(callback, options)
        observer.observe(this.$el)
    }
}

document.addEventListener('DOMContentLoaded', () => {
    Array.from(document.querySelectorAll('.oce-hero-banner')).forEach($block => {
        $block.expandygg = new HeroBanner($block)
    })
}, {capture: false, passive: true, once: true} || false)